import {
  ADD_CUSTOMER_GROUPS,
  REFRESH_CUSTOMER_DEVICES,
} from '../actions/constants'
const initialState = {
  customerGroupList: null,
  refreshDeviceList: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_CUSTOMER_GROUPS:
      return {
        ...state,
        customerGroupList: action.payload,
      }
    case REFRESH_CUSTOMER_DEVICES:
      return {
        ...state,
        refreshDeviceList: action.payload,
      }

    default:
      return {
        ...state,
      }
  }
}
